export const isBrandsWithSuspendedAccess = (brandName: string): boolean => {
    const brandsWithSuspendedAccess: string[] = [];

    return brandsWithSuspendedAccess.includes(brandName);
};
